import { render, staticRenderFns } from "./DelPopup.vue?vue&type=template&id=611de2b1&scoped=true&"
import script from "./DelPopup.vue?vue&type=script&lang=ts&"
export * from "./DelPopup.vue?vue&type=script&lang=ts&"
import style0 from "./DelPopup.vue?vue&type=style&index=0&id=611de2b1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "611de2b1",
  null
  
)

export default component.exports